// @flow

import styled from 'styled-components'
import { Flex } from '@rebass/grid'

import { Button as ButtonBase } from '@alphaott/smart-tv-components'
import { getTextColorPrimary } from '@alphaott/smart-tv-themes'

export const Background = styled(Flex)`
  position: fixed;
  left: 0;
  top: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 10;
`

export const Container = styled.div`
  padding: 44rem 68rem 62rem;
  color: ${getTextColorPrimary};
  border-radius: 8rem;
  background: rgba(32, 32, 32, 0.8);
  box-sizing: border-box;
`

export const Actions = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10rem;
`

export const Button = styled(ButtonBase)`
  font-size: 22rem;
  margin: 1rem;
`

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 600rem;
  height: 200rem;
`
